import * as olStyle from 'ol/style';
import { getVuetifyThemeVar } from '@/utils/mapLayerTheme';
import { withOpacity } from '@/utils/map/olColor';

const getThemeVar = getVuetifyThemeVar;

/**
 * 사용자 업로드 GeoJSON — geometry 타입별 Vuetify 톤
 */
export function geoJsonFeatureStyle(feature) {
  const geometry = feature.getGeometry();
  const geometryType = geometry.getType();

  switch (geometryType) {
    case 'Polygon':
    case 'MultiPolygon':
      return new olStyle.Style({
        stroke: new olStyle.Stroke({
          color: withOpacity(getThemeVar('--v-warning-base', '#E65100'), 0.85),
          width: 2
        }),
        fill: new olStyle.Fill({
          color: withOpacity(getThemeVar('--v-warning-base', '#E65100'), 0.3)
        })
      });

    case 'LineString':
    case 'MultiLineString':
      return new olStyle.Style({
        stroke: new olStyle.Stroke({
          color: withOpacity(getThemeVar('--v-accent-base', '#82B1FF'), 0.8),
          width: 3
        })
      });

    case 'Point':
    case 'MultiPoint':
      return new olStyle.Style({
        image: new olStyle.Circle({
          radius: 6,
          fill: new olStyle.Fill({
            color: withOpacity(getThemeVar('--v-accent-base', '#82B1FF'), 0.8)
          }),
          stroke: new olStyle.Stroke({
            color: getThemeVar('--v-accent-base', '#82B1FF'),
            width: 2
          })
        })
      });

    default:
      return new olStyle.Style({
        stroke: new olStyle.Stroke({
          color: withOpacity(getThemeVar('--v-secondary-base', '#7A6F83'), 0.8),
          width: 2
        }),
        fill: new olStyle.Fill({
          color: withOpacity(getThemeVar('--v-secondary-base', '#7A6F83'), 0.3)
        })
      });
  }
}
